<template>
  <div class="login-wrapper">
    <div class="login-card">
      <div class="login-header">
        <img src="@/assets/logo.jpg" alt="logo" class="logo" />
        <h2>个人志愿管理系统</h2>
        <p>仅获得许可的管理员登录，无法注册</p>
      </div>

      <form @submit.prevent="login" class="login-form">
        <div class="form-group">
          <el-input
              v-model="username"
              placeholder="用户名"
              prefix-icon="el-icon-user"
              clearable
              autocomplete="username"
              size="medium"
          />
        </div>

        <div class="form-group">
          <el-input
              v-model="password"
              placeholder="密码"
              prefix-icon="el-icon-lock"
              show-password
              autocomplete="current-password"
              size="medium"
          />
        </div>

        <div class="form-options">
          <label>
            <input type="checkbox" v-model="remember" /> 记住我
          </label>
          <a href="#">忘记密码?</a>
        </div>

        <button type="submit" class="login-button">登 录</button>
      </form>

      <div class="login-footer">
        个人志愿管理系统 © 2025
      </div>
    </div>
    <footer class="footer">
      <div class="footer-content">
        <p>个人志愿管理系统 <img src="@/assets/icp.png" alt="icp" class="icp" /><a href="https://beian.mps.gov.cn/#/query/webSearch?code=13010202004398" rel="noreferrer" target="_blank">冀公网安备13010202004398号</a> 备案号：<a href="http://beian.miit.gov.cn/" target="_blank">冀ICP备2025128772号-1</a></p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'MyLogin',
  data () {
    const remembered = localStorage.getItem('remember_username') || ''
    return {
      username: remembered,
      password: '',
      remember: !!remembered,
      loading: false,
      showPwd: false
    }
  },
  methods: {
    onForgot() {
      this.$message.info('请联系管理员重置密码')
    },
    async login() {
      if (this.loading) return
      if (!this.username || !this.password) {
        this.$message.warning('请填写完整用户名与密码')
        return
      }
      this.loading = true
      try {
        const payload = {
          loginId: this.username,
          password: this.password
        }
        // 第三个参数是 axios 配置，这里显式跳过加密
        const res = await this.$axios.post('/api/volunteerManage/user/login', payload)
        if (res && (res.code === 200 || res.code === '200')) {
          // 记住我：仅记用户名
          if (this.remember) {
            localStorage.setItem('remember_username', this.username)
          } else {
            localStorage.removeItem('remember_username')
          }
          const token = res.data.token;
          const userId= res.data.userId;
          // 保存登录态（按你的 store action 名称）
          this.$store.dispatch('login', {
            token: token,
            userId: userId
          })
          this.$message.success('登录成功')
          this.$router.push('/items')
        } else {
          this.$message.error("账号或密码错误，请重新输入！");
        }
      } catch (e) {
        const msg =
            (e && e.response && (e.response.data?.msg || e.response.data?.message)) ||
            e.message ||
            '登录失败，请稍后再试'
        this.$message.error(msg)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
/* 背景和整体居中布局 */
.login-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f0f2f5;
  font-family: 'Segoe UI', 'PingFang SC', sans-serif;
}

/* 卡片样式 */
.login-card {
  width: 380px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 40px 30px;
  box-sizing: border-box;
  text-align: center;
  animation: fadeIn 0.4s ease;
}

/* 头部样式 */
.login-header {
  margin-bottom: 30px;
}

.login-header .logo {
  width: 100px;
  height: 100px;
  margin-bottom: 12px;
}

.login-header h2 {
  margin-bottom: 6px;
  font-size: 22px;
  font-weight: 600;
  color: #333;
}

.login-header p {
  font-size: 14px;
  color: #888;
}

/* 表单样式 */
.form-group {
  position: relative;
  margin-bottom: 18px;
}
.icp{
  width: 16px;
}
.input-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #aaa;
  font-size: 16px;
}

input {
  width: 100%;
  padding: 10px 36px 10px 36px; /* 为左右图标留空 */
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

input:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
  outline: none;
}

.pwd-toggle {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #909399;
  cursor: pointer;
  font-size: 16px;
}

/* 记住我 */
.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  margin-bottom: 20px;
}

.form-options a {
  color: #409eff;
  text-decoration: none;
}

.form-options a:hover {
  text-decoration: underline;
}

/* 按钮 */
.login-button {
  width: 100%;
  padding: 12px;
  background-color: #409eff;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s;
}

.login-button:hover {
  background-color: #66b1ff;
}

.login-button:disabled {
  opacity: .7;
  cursor: not-allowed;
}

/* 底部版权 */
.login-footer {
  margin-top: 20px;
  font-size: 12px;
  color: #999;
}
/* 让 Element 的输入框铺满且不超出卡片 */
.login-form .el-input {
  width: 100%;
}

.login-form .el-input__inner {
  height: 40px;              /* 比默认稍高，手感更好 */
  box-sizing: border-box;    /* ✅ 防止撑破 */
  font-size: 14px;
}

/* 与原有间距统一 */
.form-group {
  margin-bottom: 18px;
}
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  background-color: #f8f8f8;
  padding: 10px 0;
  font-size: 14px;
}

.footer-content a {
  color: #007BFF;
  text-decoration: none;
}

.footer-content a:hover {
  text-decoration: underline;
}
/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式 */
@media (max-width: 480px) {
  .login-card {
    width: 90%;
    padding: 30px 20px;
  }
}
</style>
